
import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { NavigationBar } from "components/common/NavigationBar";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { GIGActivation } from "./GIGActivation";
import { GIGPrecontract } from "./GIGPrecontract";
import { GIGPromotion } from "./GIGPromotion";
import { GIGRoutes } from "./GIGRoutes";
import { GIGSigning } from "./GIGSigning";
import { GIGStore } from "./GIGStore";
import { GIGSuccess } from "./GIGSuccess";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class GIGContainer extends React.Component<IProps, {}> {
    store: GIGStore;

    constructor(props: any) {
        super(props);
        this.store = new GIGStore();
    }

    async componentDidMount() {
        try {
            if (auth.authorized) {
                await this.store.load();
                if (this.store.getEcommerceResponse && this.store.getEcommerceResponse.cie === "ACTIVE") {
                    pushRoute(GIGRoutes.SUCCESS);
                }
            }
        } catch (error) {
            debug.log("### GIGContainer.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    withContactsStore(Component: any) {
        return () => <Component {...this.props} contactsStore={this.store.contactsStore} />;
    }

    render() {
        document.title = ui.__("gig.document.title");

        const pages = [
            {
                path: "activation",
                title: ui.__("gig.navbar.settings")
            },
            {
                path: "precontract",
                title: ui.__("gig.precontract.header")
            }
        ];

        return (
            <div>
                <NavigationBar
                    basePath="/gig"
                    pages={pages}
                    path={this.props.location.pathname}
                    backToBase
                />

                <Route exact path={GIGRoutes.ROOT} render={this.withStore(GIGPromotion)} />
                <Route exact path={GIGRoutes.ACTIVATION} render={this.withStore(GIGActivation)} />
                <Route exact path={GIGRoutes.PRECONTRACT} render={this.withStore(GIGPrecontract)} />
                <Route exact path={GIGRoutes.SUCCESS} render={this.withStore(GIGSuccess)} />
                <Route exact path={GIGRoutes.SIGNING} render={this.withStore(GIGSigning)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/gig/GIGContainer.tsx